import axios from 'axios';


// 创建 Axios 实例
const http = axios.create({
  baseURL: window.host + '/api', // 替换为你的 API 基础 URL
  timeout: 10000, // 请求超时时间
  headers: {
    'Content-Type': 'application/json',
  },
});

// 请求拦截器
http.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么，例如添加 token
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 响应拦截器
http.interceptors.response.use(
  response => {
    // 对响应数据做点什么
    return response.data;
  },
  error => {
    // 对响应错误做点什么
    if (error.response) {
      // 请求已发出，但服务器响应的状态码不在 2xx 范围内
      console.error('Error:', error.response.data);
      // 根据需要处理不同的状态码
      switch (error.response.status) {
        case 403:
          // 错误，重定向到登录页面
          window.location.href = '/login';
          break;
        // 其他错误处理
        default:
          console.error('Error:', error.response.statusText);
      }
    } else {
      // 请求未发出或其他错误
      console.error('Error:', error.message);
    }
    return Promise.reject(error);
  }
);

export default http;

